// extracted by mini-css-extract-plugin
export default {"Month":"L0YXy","title-wrap":"WSzht","title":"G5j7I","year":"RvmYc","skeleton-progress":"z5FnI"};